(() => {
  const fmt = cents => (cents / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TL';

  function init() {
    const root = document.getElementById('evce-home');
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';

    // Mobil menü
    const menu = root.querySelector('.menu');
    const mobile = root.querySelector('.mobile-nav');
    if (menu && mobile) {
      const close = () => { mobile.classList.remove('open'); menu.setAttribute('aria-expanded', 'false'); menu.textContent = '☰'; menu.setAttribute('aria-label','Menüyü aç'); };
      menu.addEventListener('click', () => {
        const open = mobile.classList.toggle('open');
        menu.setAttribute('aria-expanded', open);
        menu.textContent = open ? '×' : '☰'; menu.setAttribute('aria-label',open ? 'Menüyü kapat' : 'Menüyü aç');
      });
      mobile.querySelectorAll('a').forEach(a => a.addEventListener('click', close));
      document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });
    }

    // Açık / kapalı görünüm
    const art = root.querySelector('.product-art');
    const title = root.querySelector('#view-title');
    const stateButtons = root.querySelectorAll('[data-state]');
    stateButtons.forEach(b => b.addEventListener('click', () => {
      const closed = b.dataset.state === 'closed';
      if (art) art.classList.toggle('closed', closed);
      if (title) title.textContent = closed ? 'İşin bitince kapat.' : 'Çamaşırların için aç.';
      stateButtons.forEach(x => { x.classList.toggle('active', x === b); x.setAttribute('aria-pressed', x === b); });
    }));

    // Satın alma: boy + adet + toplam
    const variant = root.querySelector('#evce-variant');
    if (!variant) return;
    const price = root.querySelector('#evce-price');
    const compare = root.querySelector('#evce-compare');
    const button = root.querySelector('#evce-add');
    const qtyInput = root.querySelector('#evce-quantity');
    const totalEl = root.querySelector('#evce-total');
    const tiersWrap = root.querySelector('.evce-tiers');
    const pct2 = tiersWrap ? parseFloat(tiersWrap.dataset.pct2) || 0 : 0;
    const pct3 = tiersWrap ? parseFloat(tiersWrap.dataset.pct3) || 0 : 0;
    const sizeButtons = root.querySelectorAll('.evce-size');
    const tierButtons = root.querySelectorAll('.evce-tier');

    const update = () => {
      const option = variant.selectedOptions[0];
      if (!option) return;
      const qty = Math.max(1, parseInt(qtyInput ? qtyInput.value : '1', 10) || 1);
      const unit = parseInt(option.dataset.cents, 10) || 0;
      const pct = qty >= 3 ? pct3 : (qty >= 2 ? pct2 : 0);
      const gross = unit * qty;
      const net = Math.round(gross * (1 - pct / 100));
      if (price) price.textContent = option.dataset.price;
      if (compare) { compare.textContent = option.dataset.compare || ''; compare.hidden = !option.dataset.compare; }
      if (totalEl) {
        if (qty > 1) {
          totalEl.innerHTML = 'Toplam: <strong>' + fmt(net) + '</strong>' + (pct > 0 ? ' <s>' + fmt(gross) + '</s> <span>' + fmt(gross - net) + ' kazanç</span>' : '');
          totalEl.hidden = false;
        } else {
          totalEl.hidden = true;
        }
      }
      if (button) {
        button.disabled = option.dataset.available !== 'true';
        button.textContent = button.disabled ? 'Tükendi' : (qty > 1 ? qty + ' adet sepete ekle' : 'Sepete ekle');
      }
    };

    sizeButtons.forEach(b => b.addEventListener('click', () => {
      variant.value = b.dataset.variant;
      sizeButtons.forEach(x => { x.classList.toggle('active', x === b); x.setAttribute('aria-checked', x === b); });
      update();
    }));
    tierButtons.forEach(b => b.addEventListener('click', () => {
      if (qtyInput) qtyInput.value = b.dataset.qty;
      tierButtons.forEach(x => x.classList.toggle('active', x === b));
      update();
    }));
    variant.addEventListener('change', update);
    update();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', () => {
    const root = document.getElementById('evce-home');
    if (root) delete root.dataset.initialized;
    init();
  });
})();
